export default __webpack_public_path__ + "static/media/youtube.8e1968d2.svg";